export default __webpack_public_path__ + "static/features-timeline-d8ea9cc9b414336e5cc4a6705f5d8a63.png";